module.exports = __webpack_public_path__ + "img/回顶部.eff0d5d1.svg";